module.exports = __webpack_public_path__ + "img/nordaxbank@2x.96fb99a.png";